import { alpha, Box, Button, Typography } from "@mui/material";
import { READABLE_BODY_SX } from "src-next/modules/clinical-insights/constants/clinicalInsightsTheme";

interface InsightFilterActiveFooterProps {
  accentColor: string;
  activeFilterCount: number;
  onClear: () => void;
}

export function InsightFilterActiveFooter({
  accentColor,
  activeFilterCount,
  onClear,
}: InsightFilterActiveFooterProps) {
  if (activeFilterCount <= 0) return null;

  return (
    <Box
      sx={{
        px: 1.5,
        py: 1.25,
        borderRadius: 1.5,
        border: "1px solid",
        borderColor: alpha(accentColor, 0.35),
        bgcolor: alpha(accentColor, 0.08),
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        gap: 1,
      }}
    >
      <Typography fontWeight={600} sx={READABLE_BODY_SX}>
        {activeFilterCount} filtros ativos
      </Typography>
      <Button onClick={onClear} sx={{ color: accentColor, fontWeight: 700, ...READABLE_BODY_SX }}>
        Limpar
      </Button>
    </Box>
  );
}
